export function luminanace(r, g, b) {
  var a = [r, g, b].map(function(v) {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}

export function contrast(rgb1, rgb2) {
  var lum1 = luminanace(rgb1[0], rgb1[1], rgb1[2]);
  var lum2 = luminanace(rgb2[0], rgb2[1], rgb2[2]);
  var brightest = Math.max(lum1, lum2);
  var darkest = Math.min(lum1, lum2);
  return (brightest + 0.05) / (darkest + 0.05);
}

/**
 * Convert rgba to rgb: Color * alpha + Background * (1 - alpha);
 *
 * @param {Array} color - Array of the rgb values
 * @param {Float} alpha - Alpha value of the color
 * @param {Array} background - Array of the rgb values
 */
export function convertRGBAtoRGB(color, alpha, background) {
  return [
    // red
    color[0] * alpha + background[0] * (1 - alpha),
    // green
    color[1] * alpha + background[1] * (1 - alpha),
    // blue
    color[2] * alpha + background[2] * (1 - alpha)
  ];
}

export const rgb = {
  toArray(rgbString) {
    const matchColors = /rgb\((\d{1,3}), (\d{1,3}), (\d{1,3})\)/;
    const match = matchColors.exec(rgbString);
    if (match !== null) {
      return match.splice(1, match.length).map(e => +e);
    } else {
      throw new Error(`Can't parse rgb color string`);
    }
  },
  toString(rgbArray, alpha) {
    if (alpha) {
      return `rgba(${rgbArray.join(',')}, ${alpha})`;
    } else {
      return `rgb(${rgbArray.join(',')})`;
    }
  }
};

export function hexToRGB(hex) {
  if (hex && !hex.startsWith('#')) return;
  if (hex) {
    const rgb = hex
      .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b)
      .substring(1)
      .match(/.{2}/g)
      .map(x => parseInt(x, 16));
    return rgb;
  }
}

export function hexToRGBA(hex, alpha) {
  if (hex && !hex.startsWith('#')) return;
  if (hex) {
    const rgb = hexToRGB(hex);
    return `rgba(${rgb.join(',')}, ${alpha})`;
  }
}
